import O1HD from "../../../../engines/gameEngine";
import utilsView from "../../../../engines/libs/utilsView";
import { FileKind } from "../../../define/FileKind";
import NormalGameManager from "../../manager/NormalGameManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class takeCowSynthesisPage extends cc.Component {

    @property({type:cc.Node,tooltip:"牛的图片layout"})
    cowLayout:cc.Node = null;

    onBtnSynthesis(){
        NormalGameManager._instance.setGameData({takeCowAlreadyWave:[]});
        NormalGameManager._instance.onPushGoods(50022,1);
        O1HD.emit("normalMode.updateLieYing");
        O1HD.emit("takeCow.updateTakeCowAlreadly");
        let fun = (node:cc.Node)=>{
            this.closeThis();
        }
        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.takeCowSynthesisSuccessPage,null,null,null,fun
        );
    }

    onBtnCloseThis(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.closeThis();
    }

    closeThis(){
        this.node.destroy();
    }
}
